import { tokens } from "@core/theme/tokens";

// Compartido por la Bitácora de accesos y la Traza HTTP (Seguridad): ambas
// pantallas comparten la misma barra de filtros y el mismo diálogo de
// "Filtros adicionales" — jscpd marcó estos fragmentos como clon exacto
// entre `accessLogStyles.ts` y `httpRequestLogStyles.ts` (quality-gate,
// revisión de duplicación 2026-09-23). Cada pantalla conserva sus propios
// estilos de tabla/badges, que sí difieren.
export const securityLogFilterBarStyles = {
  filterBar: { padding: 14, gap: 12, marginBottom: 16 },
  filterInput: {
    background: tokens.surface.surface,
    border: `1px solid ${tokens.surface.line}`,
    borderRadius: tokens.radius.sm,
    color: tokens.text.primary,
    font: `400 12px ${tokens.font.ui}`,
    padding: "8px 10px",
  },
  advancedFilters: {
    description: {
      margin: "0 0 20px",
      color: tokens.text.tertiary,
      font: `400 12px/1.55 ${tokens.font.ui}`,
    },
    fields: {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      gap: 14,
    },
    label: {
      display: "grid",
      gap: 7,
      color: tokens.text.tertiary,
      font: `500 11.5px ${tokens.font.ui}`,
    },
  },
} as const;
